"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _uuid = require("uuid");
var _TotalCount = _interopRequireDefault(require("../widgets/TotalCount.widget"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class OctaviHighlights extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      startAt: null,
      endAt: null,
      selectedWidgets: _OctaviParameters.default.selectedWidgets
    };
    this.onWidgetAdd = this.onWidgetAdd.bind(this);
    this.onWidgetDelete = this.onWidgetDelete.bind(this);
    this.updateWidgetSelection = this.updateWidgetSelection.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on('taxi.filter.selectedWidgets.add', this.onWidgetAdd);
    _ServiceLocator.default.eventManager.on('taxi.filter.selectedWidgets.delete', this.onWidgetDelete);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.filter.selectedWidgets.add', this.onWidgetAdd);
    _ServiceLocator.default.eventManager.off('taxi.filter.selectedWidgets.delete', this.onWidgetDelete);
  }
  onWidgetAdd(widgetInfo, widgetOptions) {
    let newSelectedWidgets;
    if (this.state.selectedWidgets === undefined) {
      newSelectedWidgets = {};
    } else {
      newSelectedWidgets = _objectSpread({}, this.state.selectedWidgets);
    }
    const newUuid = (0, _uuid.v4)();
    newSelectedWidgets[newUuid] = _objectSpread(_objectSpread({}, widgetInfo), {}, {
      options: widgetOptions ? widgetOptions : {},
      uuid: newUuid
    });
    this.setState({
      selectedWidgets: newSelectedWidgets
    });
    _OctaviParameters.default.selectedWidgets = newSelectedWidgets;
    _ServiceLocator.default.eventManager.emit(`taxi.widget.${newUuid}SelectOptions.update`);
    this.updateWidgetSelection();
  }
  onWidgetDelete(uuid) {
    let newSelectedWidgets = _objectSpread({}, this.state.selectedWidgets);
    delete newSelectedWidgets[uuid];
    this.setState({
      selectedWidgets: newSelectedWidgets
    });
    _OctaviParameters.default.selectedWidgets = newSelectedWidgets;
    this.updateWidgetSelection();
  }
  updateWidgetSelection() {
    let newSelectedWidgets = _OctaviParameters.default.selectedWidgets;
    this.setState({
      selectedWidgets: newSelectedWidgets
    });
  }
  getSelectedWidgetComponents(selectedWidgets) {
    const widgets = [];
    for (let widgetUuid in selectedWidgets) {
      const widgetSpecs = selectedWidgets[widgetUuid];
      widgets.push(/*#__PURE__*/_react.default.createElement(_TotalCount.default, {
        key: `widget_${widgetSpecs.uuid}`,
        uuid: widgetSpecs.uuid,
        t: this.props.t,
        i18n: this.props.i18n,
        object: widgetSpecs.object,
        customFilterString: null,
        type: widgetSpecs.type,
        labelName: widgetSpecs.labelName,
        countPerHour: true,
        countPerWeekday: true,
        widgetSpecs: widgetSpecs
      }));
    }
    return widgets;
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__widgets__container"
    }, Object.keys(this.state.selectedWidgets).length !== 0 && this.getSelectedWidgetComponents(this.state.selectedWidgets), Object.keys(this.state.selectedWidgets).length === 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__widget__container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "widget_title_width"
    }, /*#__PURE__*/_react.default.createElement("h3", null, this.props.t('octavi:widgets:noWidget')))));
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(OctaviHighlights);